export const disponibilidad = [
  "mañana",
  "tarde",
  "nocturno",
];
